import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Briefcase, Target, CheckCircle, Lightbulb } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Navigation from '@/components/Navigation';

function CareerReflectionGuide() {
  const navigate = useNavigate();

  const questions = [
    "Am I utilizing my strengths at work?",
    "Do I feel challenged and engaged?",
    "Is my work aligned with my values?",
    "Do I have opportunities to grow?",
    "Am I fairly compensated?",
    "Do I have work-life balance?",
    "Does my work give me purpose?",
    "Where do I want to be in 5 years?"
  ];

  const categories = [
    { area: "Strengths", prompt: "List 5 things you do better than most people" },
    { area: "Passions", prompt: "What work would you do even if unpaid?" },
    { area: "Market Value", prompt: "What skills are in demand that you have or could develop?" },
    { area: "Purpose", prompt: "What impact do you want to make?" }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <header className="bg-white shadow-sm border-b border-primary/10">
        <div className="container mx-auto px-6 py-6">
          <Button onClick={() => navigate(-1)} variant="ghost" className="mb-4 text-secondary-700 hover:text-primary">
            <ArrowLeft className="mr-2 w-5 h-5" /> Back
          </Button>
        </div>
      </header>

      <main className="container mx-auto px-6 py-8 max-w-4xl">
        <div className="text-center mb-8">
          <span className="inline-block px-4 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-4">
            Week 8 • Day 1 Guide
          </span>
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-secondary-900 mb-4">
            Career Reflection
          </h1>
          <p className="text-xl text-secondary-600">Assess Your Professional Journey</p>
        </div>

        <section className="bg-gradient-to-r from-blue-500 to-indigo-500 rounded-2xl p-8 text-white mb-8">
          <div className="flex items-start gap-4">
            <Briefcase className="w-12 h-12 flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-bold text-2xl mb-2">Today's Exercise</h3>
              <p className="text-blue-100 text-lg">
                Rate your career satisfaction (1-10). Are you growing? Using your strengths? 
                Earning what you're worth? Write one career goal for the next 12 months.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-white rounded-2xl p-8 shadow-md border border-gray-100 mb-6">
          <h2 className="text-2xl font-serif font-bold text-secondary-900 mb-6">Reflection Questions</h2>
          <div className="grid md:grid-cols-2 gap-3">
            {questions.map((q, i) => (
              <div key={i} className="flex items-start gap-2 p-3 bg-blue-50 rounded-lg">
                <CheckCircle className="w-4 h-4 text-blue-500 mt-1 flex-shrink-0" />
                <span className="text-secondary-700">{q}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 border-2 border-blue-200">
          <h2 className="text-2xl font-serif font-bold text-secondary-900 mb-6">Ikigai Exploration</h2>
          <div className="grid md:grid-cols-2 gap-4">
            {categories.map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-4">
                <h3 className="font-bold text-blue-700 mb-2">{item.area}</h3>
                <p className="text-sm text-secondary-600 mb-2">{item.prompt}</p>
                <div className="h-16 border-b border-blue-200"></div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

export default CareerReflectionGuide;
